import { MedplumClient } from '@medplum/core';

export const medplum = new MedplumClient({
  baseUrl: import.meta.env.VITE_MEDPLUM_BASE_URL || 'https://fhir.precisionlongevity.io/',
  clientId: import.meta.env.VITE_MEDPLUM_CLIENT_ID,
});
